import { AxiosResponse } from "axios";
import $api from "../..";

export class AdsService {
  static async requestAds(placement: string): Promise<AxiosResponse<any>> {
    return $api.get("ads/", { params: { placement } });
  }
}
